export const jwtDecoded = () => {
  const jwtToken = localStorage.getItem('jwtToken');
  if (jwtToken) {
    try {
      const base64Url = jwtToken.split('.')[1];
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      const jsonPayload = decodeURIComponent(atob(base64).split('').map(c => {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      }).join(''));
      
      return JSON.parse(jsonPayload);
    } catch (error) {
      return null;
    }
  }
  
  return null;
}

export function formatNumber(number) {
  const parts = number.toString().split('.');
  const formattedIntegerPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  let formattedNumber = formattedIntegerPart;
  if (parts.length === 2) {
    formattedNumber += ',' + parts[1];
  }

  return formattedNumber;
}

export function formatDate(date) {
  const parts = date.split('-');
  if (parts.length !== 3) {
      return '';
  }
  
  const [year, month, day] = parts;
  
  return `${day}.${month}.${year}`;
}